var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 20",
    width: 12,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 23,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAXCAMAAAAIul6NAAAAAXNSR0IB2cksfwAAAGBQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////fCUcugAAACB0Uk5TAL/MANDP/0AqxntwyKq2MaGyDZfz16QTQsXtXncmMIDxBVjrAAAAVElEQVR4nK3MRwqAQBAF0dbRMuec739Lx4C6VaxN86D5IluGKXdKKXmbZT8AX+D8BPcBD/9AQCgRxIlGCpnkBZRQQd3ox7ZD1w/n2FgSTdf0vOxnBeGGA0yT3lylAAAAAElFTkSuQmCC"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Forma 2",
    href: "#img1",
    x: 0,
    y: -3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/scroll-icon.6d03c6247c37ad6a99d2a951dae335d9.svg";
export { ForwardRef as ReactComponent };